'use strict';

import { getUserManagingOrgIds } from 'Data/context/Organizations';
import { user_org_roles } from 'Data/Enum';
import { canUserViewAllCores, isUserAuthorized } from 'Util';
import GenericTableData from './GenericTableData';

let orgToAccountMap = new Map();

// Charge Account Module Event Bus. Handles all interactions with Charge Account.
let ChargeAccountData = GenericTableData.getTableDataBus(
  'CHACC',
  'charge_accounts',
);

ChargeAccountData.fetchAccountsForOrg = (orgId, forceUpdate) => {
  if (
    !canUserViewAllCores() &&
    !isUserAuthorized({
      roles: [[`${orgId}`, user_org_roles.MANAGER]],
    })
  ) {
    return;
  }

  if (!forceUpdate && orgToAccountMap.get(`${orgId}`)) {
    let records = orgToAccountMap.get(`${orgId}`);
    ChargeAccountData.notifyListeners('ACCOUNTS_FOR_ORG_LOADED', { records });
    return records;
  }

  let where = {
    '*parent_organization_id': orgId,
    '*status': 'ACTIVE',
  };

  return ChargeAccountData.getRecordList(
    { where },
    false,
    'ACCOUNTS_FOR_ORG_LOADED',
  ).then(({ records }) => {
    orgToAccountMap.set(`${orgId}`, records);
    return records;
  });
};

ChargeAccountData.getAccountsForOrg = (orgId) => {
  if (
    !canUserViewAllCores() &&
    !isUserAuthorized({
      roles: [[`${orgId}`, user_org_roles.MANAGER]],
    })
  ) {
    return [];
  }
  return orgToAccountMap.get(`${orgId}`);
};

ChargeAccountData.getChargeAccountList = (opts) => {
  let where = {
    ...(opts?.where && { ...opts.where }),
  };
  if (
    !canUserViewAllCores() &&
    !Object.hasOwn(where, '*parent_organization_id')
  ) {
    where['*parent_organization_id'] = getUserManagingOrgIds();
  }
  let options = {
    ...opts,
    where: where,
  };
  return ChargeAccountData.getRecordList(options);
};

ChargeAccountData.updateOrCreateAccountsForOrg = (accountList, orgId) => {
  ChargeAccountData.updateOrCreateRecords(accountList)
    .then(() => {
      orgToAccountMap.delete(`${orgId}`);
    })
    .then(() => {
      ChargeAccountData.fetchAccountsForOrg(orgId).then((accounts) => {
        ChargeAccountData.notifyListeners('ACCOUNTS_FOR_ORG_MODIFIED', {
          orgId,
          accounts,
        });
      });
    });
};

ChargeAccountData.createAccount = (recordData) => {
  let orgId = recordData.parent_organization_id;
  ChargeAccountData.createRecord(recordData)
    .then(() => {
      orgToAccountMap.delete(`${orgId}`);
    })
    .then(() => {
      ChargeAccountData.fetchAccountsForOrg(orgId).then((accounts) => {
        ChargeAccountData.notifyListeners('ACCOUNTS_FOR_ORG_MODIFIED', {
          orgId,
          accounts,
        });
      });
    });
};

ChargeAccountData.deleteAccount = (recordData) => {
  let orgId = recordData.parent_organization_id;
  ChargeAccountData.deleteRecords([recordData.id])
    .then(() => {
      orgToAccountMap.delete(`${orgId}`);
    })
    .then(() => {
      ChargeAccountData.fetchAccountsForOrg(orgId).then((accounts) => {
        ChargeAccountData.notifyListeners('ACCOUNTS_FOR_ORG_MODIFIED', {
          orgId,
          accounts,
        });
      });
    });
};

ChargeAccountData.updateAccount = (recordData) => {
  let orgId = recordData.parent_organization_id;
  ChargeAccountData.updateRecord(recordData)
    .then(() => {
      orgToAccountMap.delete(`${orgId}`);
    })
    .then(() => {
      ChargeAccountData.fetchAccountsForOrg(orgId).then((accounts) => {
        ChargeAccountData.notifyListeners('ACCOUNTS_FOR_ORG_MODIFIED', {
          orgId,
          accounts,
        });
      });
    });
};

export default ChargeAccountData;
